import styled from 'styled-components';
import { ReactComponent as ErrorIcon } from '../../assets/icon_error.svg';
import { useContext } from 'react';
import { PageContext } from '../../context/context';

export function Error() {
    const { errorMessage } = useContext(PageContext);
    return (
        <StyledError>
            <StyledErrorContent>
                <ErrorIcon />

                <div>
                    <p>Что-то пошло не так.</p>
                    <p>
                        {errorMessage
                            ? errorMessage
                            : 'Отменить запись не получилось. '}
                    </p>
                    <p>
                        Отмените запись в личном кабинете или позвоните нам{' '}
                        <a href="tel:+7(812)380-02-38">+7 (812) 380-02-38</a>
                    </p>
                </div>

                <StyledErrorLink href="https://mc21.ru/lk">
                    Перейти в личный кабинет
                </StyledErrorLink>
            </StyledErrorContent>
        </StyledError>
    );
}

const StyledErrorLink = styled.a`
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    text-decoration: underline;
    text-decoration-skip-ink: none;
    text-align: center;
    color: #82bf31;
    &:hover {
        opacity: 0.8;
    }
`;

const StyledError = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    background: #fff;
    padding-top: 40px;
    padding-bottom: 40px;
    padding-right: 24px;
    padding-left: 24px;
`;
const StyledErrorContent = styled.div`
    max-width: 308px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 40px;
    && p {
        font-weight: 600;
        font-size: 16px;
        line-height: 140%;
        padding: 0 !important;
        margin: 0;
        text-align: left;
        a {
            font-weight: 700;
        }
    }
    && p:not(:last-child) {
        margin-bottom: 16px;
    }
    && a {
        font-weight: 600;
        font-size: 16px;
        line-height: 140%;
    }
`;
